export const IS_EQUAL = (state) => {
  return state.password === state.confirm
}

export const getValue = (state) => (key) => {
  return state[key]
}

export const getConfirm = (state) => {
  return state.confirm
}
